import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SyncScrollDirective } from "./sync-scroll.directive";

@NgModule({
  declarations: [SyncScrollDirective],
  imports: [CommonModule],
  exports: [SyncScrollDirective],
})
export class SyncScrollModule {}
